module.exports={
	"Form": "PhysicalAssetViewManifest",
	"Scope": "PhysicalAsset-View",
	"Descriptors":
	{
		"PhysicalAssetDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAsset-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "PhysicalAsset-View-Identity",
				"Group": "PhysicalAsset-View-Identity"
			}
		},
		"PhysicalAssetDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAsset-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.OriginLatitude":
		{
			"Name": "Origin Latitude",
			"Hash": "PhysicalAsset-View-OriginLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.OriginLongitude":
		{
			"Name": "Origin Longitude",
			"Hash": "PhysicalAsset-View-OriginLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLatitude":
		{
			"Name": "Bounding Min Latitude",
			"Hash": "PhysicalAsset-View-BoundingMinLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLatitude":
		{
			"Name": "Bounding Max Latitude",
			"Hash": "PhysicalAsset-View-BoundingMaxLatitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMinLongitude":
		{
			"Name": "Bounding Min Longitude",
			"Hash": "PhysicalAsset-View-BoundingMinLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.BoundingMaxLongitude":
		{
			"Name": "Bounding Max Longitude",
			"Hash": "PhysicalAsset-View-BoundingMaxLongitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.IDAssetClassification":
		{
			"Name": "Asset Classification",
			"Hash": "PhysicalAsset-View-IDAssetClassification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "AssetClassification",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.IDAssetType":
		{
			"Name": "Asset Type",
			"Hash": "PhysicalAsset-View-IDAssetType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "AssetType",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.ParentIDPhysicalAsset":
		{
			"Name": "Parent Physical Asset",
			"Hash": "PhysicalAsset-View-ParentIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "PhysicalAsset",
				"SearchFields":
				[
					"Name",
					"Description",
					"AssetNumber"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.ManifestVersion":
		{
			"Name": "Manifest Version",
			"Hash": "PhysicalAsset-View-ManifestVersion",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.AssetNumber":
		{
			"Name": "Asset Number",
			"Hash": "PhysicalAsset-View-AssetNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.YearBuilt":
		{
			"Name": "Year Built",
			"Hash": "PhysicalAsset-View-YearBuilt",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details"
			}
		},
		"PhysicalAssetDetails.IDFIPSState":
		{
			"Name": "FIPSState",
			"Hash": "PhysicalAsset-View-IDFIPSState",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "FIPSState",
				"SearchFields":
				[
					"Code",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.IDFIPSCounty":
		{
			"Name": "FIPSCounty",
			"Hash": "PhysicalAsset-View-IDFIPSCounty",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "7",
				"Width": 4,
				"Section": "PhysicalAsset-View-Details",
				"Group": "PhysicalAsset-View-Details",
				"Entity": "FIPSCounty",
				"SearchFields":
				[
					"Code",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetDetails.IDPhysicalAsset":
		{
			"Name": "IDPhysical Asset",
			"Hash": "PhysicalAsset-View-IDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.GUIDPhysicalAsset":
		{
			"Name": "GUIDPhysical Asset",
			"Hash": "PhysicalAsset-View-GUIDPhysicalAsset",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAsset-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAsset-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAsset-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		},
		"PhysicalAssetDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAsset-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "PhysicalAsset-View-DataAudit",
				"Group": "PhysicalAsset-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAsset-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAsset-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAsset-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAsset-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAsset-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAsset-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
